import React from 'react';

function CategoriesAndLinks({category="", links=[]}) {
  return (
    <div>
      <h2>{category}</h2>
      <ul>
        {links.map((link, index) => (
          <li key={category+index}><a href={link.url} target="_blank" rel="noreferrer">{link.display}</a></li>
        ))}
      </ul>
    </div>
  );
}

// Export the component so it can be used in other files
export default CategoriesAndLinks;